<template>
  <aha-modal
    @hide="$emit('hide')"
    :title="$i18nPresenter.t('Share Slides')"
  >
    <p class="mb-4" v-html="$i18nPresenter.t('Anyone with the link can view your slides with audience responses.')" />
    <div class="relative">
      <div class="flex flex-col gap-4">
        <aha-checkbox
          @change="(val) => updateAttribute('enableCopySlideNote', val)"
          :checked="presentation?.enableCopySlideNote"
        >
          <span>{{ $i18nPresenter.t("Include slide notes") }}</span>
          <i name="slide-notes" class="text-base-55 ml-2 fas fa-question-circle " />
        </aha-checkbox>
        <aha-checkbox
          @change="(val) => updateAttribute('disableConversationPresenterShare', !val)"
          :checked="!presentation?.disableConversationPresenterShare"
        >
          <span>{{ $i18nPresenter.t("Allow comments") }}</span>
          <i name="allow-comment" class="text-base-55 ml-2 fas fa-question-circle " />
        </aha-checkbox>
      </div>
    </div>
    <template #action>
      <div class="flex justify-between w-full">
        <aha-antd-button
          name="copy-shared-slides-link-button"
          v-aha-emit-action
          @click="copyURL"
          variant="secondary"
        >
          <aha-icon
            height="20"
            name="link-icon"
            viewBox="0 0 18 14"
            class="mr-2"
          />
          {{ $i18nPresenter.t('Copy link') }}
        </aha-antd-button>

        <aha-antd-button
          name="shared-slides-modal-done-button"
          v-aha-emit-action
          variant="secondary"
          @click="$emit('hide')"
        >
          {{ $i18nPresenter.t('Done') }}
        </aha-antd-button>
      </div>
    </template>
    <aha-toggle-tip
      to="slide-notes"
      :text="$i18nPresenter.t('Receiver can see your notes when they copy this presentation to their account')"
      :popperOptions="popperOptions"
    >
    </aha-toggle-tip>
    <aha-toggle-tip
      to="allow-comment"
      :text="$i18nPresenter.t('Anyone with the link can leave a comment on the shared presentation')"
      :popperOptions="popperOptions"
    >
    </aha-toggle-tip>
  </aha-modal>
</template>
<script>
import { mapActions } from 'vuex'
import ShareACopy from '@/components-v2/presentation-editor/collaboration/ShareACopy.vue'

export default {
  extends: ShareACopy,
  data() {
    return {
      popperOptions: {
        modifiers: {
          preventOverflow: {
            escapeWithReference: true,
          },
        },
      },
    }
  },
  methods: {
    ...mapActions(['updatePresentationByIdAction']),
    // override because this tracking method is deprecated.
    trackClickShare() {},
    updateAttribute(attribute, value) {
      if (!this.presentation?.id) return
      this.updatePresentationByIdAction({
        id: this.presentation.id,
        payload: {
          [attribute]: value,
        },
      })
    },
  },
}
</script>
